export default {
      id: "sli-close-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.b3fb107f.svg#sli-close",
      toString: function () {
        return this.url;
      }
    }